export const defaultTheme = {
  white: "#fff",

  "gray-50": "#eeeeee",
  "gray-100": "#B9B9C1",
  "gray-300": "#838390",
  "gray-400": "#52525C",
  "gray-500": "#3A3A41",
  "gray-700": "#222226",
  "gray-900": "#0A0A0B",

  "green-300": "#00B37E",
  "green-500": "#00875F",
  "green-700": "#015F43",

  // Escala principal da marca baseada em #086b97
  "blue-50": "#E6F3F8",
  "blue-100": "#CDE8F1",
  "blue-300": "#69BAD5",
  "blue-400": "#37A3C7",
  "blue-500": "#086B97",
  "blue-700": "#065174",
  "blue-900": "#033550",

  // Mantidas por compatibilidade com componentes existentes
  "purple-100": "#CDE8F1",
  "purple-300": "#69BAD5",
  "purple-400": "#37A3C7",
  "purple-500": "#086B97",
  "purple-700": "#065174",
  "purple-900": "#033550",

  "red-100": "#FF9999",
  "red-300": "#FF6666",
  "red-400": "#FF3333",
  "red-500": "#FF0000",
  "red-700": "#CC0000",
  "red-900": "#990000",
} as const;
